import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store'; // ✅ Import Vuex store

import eventRoutes from './event';
import publicRoutes from './public';
import affiliates from './affiliates';
import promo from './promo';
import credentialCourse from './credentialCourse';
import payment from './payment';
import proxy from './proxy';

const routes = [...publicRoutes, ...affiliates, ...eventRoutes, ...promo, ...credentialCourse, ...payment, ...proxy, {path: '*', redirect: '/'}];

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    linkActiveClass: 'is-active',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

import middleware from '../middleware';
middleware(router);

// ✅ Custom route guard logic using authUser from Vuex
router.beforeEach((to, from, next) => {
  /**
   * Hand every dashboard route to the server.
   *
   * RedirectDashboardToLearnerPortal is Laravel middleware, so it only sees full
   * page loads — an in-app router-link or $router.push never reaches it, and
   * this SPA has ~75 links into /dashboard. Forcing a document load lets that
   * middleware map the path and 302, which keeps ONE mapping table
   * (app/Support/LearnerPortal/DashboardRouteMap.php) rather than a second copy
   * here that would drift from it.
   *
   * Only for in-app navigations: if the first navigation after a page load is a
   * dashboard path, the server let it through (the redirect is switched off),
   * and reloading it again would loop forever. vue-router's start route is the
   * only one with nothing matched.
   */
  if (to.path.startsWith('/dashboard') && from.matched.length) {
    window.location.href = to.fullPath;

    return;
  }

  const authUser = store.state.auth.me || [];

  if (authUser && !Array.isArray(authUser)) {
    const roles = authUser.roles?.data || [];
    const isMember = roles.some(role => role.name === 'member');
    
     if (to.path.startsWith('/masterclass/') && isMember && !to.path.endsWith('/subscribers') && !to.path.includes('/confirmation')) {
      return next(`${to.path}/subscribers`);
    }
  }

  return next();
});


export default router;


